import { apiFetch, apiFetchJson } from '@wundo/client/api.ts';

export type MaintenanceRunStatus =
  | 'pending'
  | 'running'
  | 'finished'
  | 'failed'
  | 'cancelled';

export interface MaintenanceRun {
  id: string;
  task: string;
  status: MaintenanceRunStatus;
  user_id: string | null;
  started_by_id: string | null;
  started_by_email: string | null;
  users_done: number;
  users_total: number | null;
  report: Record<string, number>;
  error: string | null;
  started_at: string | null;
  finished_at: string | null;
  created_at: string;
}

export interface MaintenanceTask {
  name: string;
  title: string;
  description: string;
  /** Newest first. */
  runs: MaintenanceRun[];
}

/** The run in front, if it is still going. Only the newest one ever is. */
export function activeRunOf(task: MaintenanceTask): MaintenanceRun | null {
  const run = task.runs[0];
  if (!run) return null;
  return run.status === 'pending' || run.status === 'running' ? run : null;
}

export async function listMaintenanceTasks(): Promise<MaintenanceTask[]> {
  const { items } = await apiFetchJson<{ items: MaintenanceTask[] }>(
    '/maintenance-tasks',
  );
  return items;
}

/** Start a task, optionally narrowed to one user. */
export async function runMaintenanceTask(
  task: string,
  userId: string | null,
): Promise<MaintenanceRun> {
  return apiFetchJson<MaintenanceRun>(`/maintenance-tasks/${task}/actions/run`, {
    method: 'POST',
    body: JSON.stringify({ user_id: userId }),
  });
}

export async function cancelMaintenanceRun(runId: string): Promise<void> {
  await apiFetch(`/maintenance-runs/${runId}/actions/cancel`, { method: 'POST' });
}
